exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-wrapper {\n  width: 100%;\n  border: solid 0.5px #babbc7;\n  border-radius: 4px;\n  padding: 10px 20px 7px 20px;\n  text-align: left;\n  max-height: 153px;\n  overflow: scroll; }\n  .table-wrapper .element {\n    font-family: Roboto;\n    font-size: 12px;\n    color: #5b6779;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis; }\n  .table-wrapper .two-columns > div {\n    display: inline-block;\n    width: 49%;\n    vertical-align: top; }\n  .table-wrapper .two-columns > div:first-of-type {\n    border-right: solid 0.5px #babbc7;\n    padding-right: 20px; }\n  .table-wrapper .two-columns > div:last-of-type {\n    padding-left: 20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/simple-scrollable-table/simple-scrollable-table.component.scss
// module id = ../../../../../src/app/shared/components/simple-scrollable-table/simple-scrollable-table.component.scss
// module chunks = 12